export default __webpack_public_path__ + "static/media/Fox02.aa411799.svg";